import styled from 'styled-components';
import Icon from '@minecraft.icon';
import { media } from '@minecraft.themes';

export const FilterBasicButtonContainer = styled.div`
  position: relative;
  padding-bottom: 1.125rem;

  ${media.sm`
    padding-bottom: 1rem;
  `}
`;

export const StyledFiltersAplliedIndicator = styled.span`
  position: absolute;
  top: -0.4rem;
  right: -0.4rem;
  border-radius: 50%;
  background: ${(props): string => props.theme.colors.accent.orange};
  width: 0.8rem;
  height: 0.8rem;
`;

export const FilterBasicButtonLabel = styled.span`
  margin-right: 2.875rem;
  font-size: 1rem;
  font-weight: 600;

  ${media.sm`
    font-size: .75rem;
  `}
`;

export const FilterIcon = styled(Icon)`
  margin-right: 0.3125rem;
  height: 1rem;
  width: 1rem;
`;

export const ArrowIcon = styled(Icon)`
  margin-left: auto;
  height: 0.75rem;
  width: 0.75rem;
`;

export const HintText = styled.div`
  color: ${(props): string => props.theme.filters.color};
  font-size: 0.75rem;
  font-style: italic;
  position: absolute;
  left: 0;
  bottom: 0;
  white-space: nowrap;

  ${media.sm`
    font-size: 0.625rem;
  `}
`;
